export default __webpack_public_path__ + "static/media/kitchen5-afterA-480w.dfe84714.webp";